import type { FC } from 'react'

export interface Props {
  label: string | JSX.Element
  value: string | JSX.Element
}

export const ListItem: FC<Props> = ({ label, value }) => {
  return (
    <div className="flex items-center justify-between gap-2 text-sm">
      <p className="flex items-center gap-1 font-bold">{label}</p>
      <div className="flex items-center gap-2 whitespace-nowrap font-medium text-secondary-300">
        {value}
      </div>
    </div>
  )
}
